"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// @insided/destination/icons/ArrowDropdown.tsx
// Source: /frontend/js/src/preact-components/assets/icon-arrow-dropdown.tsx
var ArrowDropdown = function ArrowDropdown(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M7 10L12 15L17 10H7Z"
  }));
};

var _default = ArrowDropdown;
exports.default = _default;